import React, { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import domainModel from 'domain-model';
import { faShippingFast } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PrivabWarehouseIndicator from '../icons/PrivabWarehouseIndicator';

_.mixin(require('lodash-uuid'));

const privabColorCodes = {
  warning: '#EF8B14',
  danger: '#AD1D17',
  success: '#2F733C',
};
function WarehouseStatusIndicator({ size, article, shopConfig }) {
  const [isOpen, setIsOpen] = useState(false);
  const toolTipTargetId = ['deliveryToolTip', article.id].join('-');
  const status = domainModel.article.warehouseStatus(article);

  const toggleTooltip = () => setIsOpen(!isOpen);
  const tooltipText = `${status.text} ${domainModel.article.deliveryStatus(
    article,
  )}`;

  return (
    <>
      <span id={toolTipTargetId}>
        {domainModel.shopConfig.isPrivabShop(shopConfig) && (
          <span>
            <PrivabWarehouseIndicator stroke={privabColorCodes[status.color]} />
          </span>
        )}
        {!domainModel.shopConfig.isPrivabShop(shopConfig) && (
          <span
            className={
              status.isPossibleToOrder ? `text-${status.color}` : 'd-none'
            }
          >
            <FontAwesomeIcon
              className="d-inline"
              size={size}
              icon={faShippingFast}
            />
          </span>
        )}
      </span>
      <Tooltip
        isOpen={isOpen}
        target={toolTipTargetId}
        toggle={toggleTooltip}
        placement="top-end"
      >
        {tooltipText}
      </Tooltip>
    </>
  );
}

WarehouseStatusIndicator.propTypes = {
  article: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['1x', '2x', '3x', 'xs', 'sm', 'md', 'lg', 'xl']),
  shopConfig: PropTypes.object,
};

WarehouseStatusIndicator.defaultProps = {
  size: '1x',
  shopConfig: null,
};

const mapStateToProps = ({ shopConfig }) => ({
  shopConfig,
});

export default connect(mapStateToProps)(WarehouseStatusIndicator);
